import {
  Component,
  OnInit,
  Input,
  forwardRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SelectComponent),
    },
  ],
})
export class SelectComponent implements OnInit {
  @Input() items = [];
  @Input() formControlName = '';
  @Input() isValid = false;
  @Input() clientError = '';
  @Input() serverError = '';
  @Input() label = '';
  @Input() parentForm: FormGroup;
  @Input() bindLabel = '';
  @Input() bindValue = '';
  @Input() multi = false;
  @Input() closeOnSelect = true;
  @Input() isNormal = false;
  @Input() selectedValue = '';
  @Input() name = '';
  @Input () hidden:any;
  @Input() pageType ='';
  @Output() handleChange = new EventEmitter();
  @Output() handleClear = new EventEmitter();

  constructor() {}

  ngOnInit(): void {
  }

  onChange: any = () => {};
  onTouch: any = () => {};
  val = ''; // this is the updated value that the class accesses
  set value(val) {
    // this value is updated by programmatic changes if( val !== undefined && this.val !== val){
    this.val = val;
    this.onChange(val);
    this.onTouch(val);
  }
  // this method sets the value programmatically
  writeValue(value: any) {
    this.value = value;
  }

  // upon UI element value changes, this method gets triggered
  registerOnChange(fn: any) {
    this.onChange = fn;
  }
  // upon touching the element, this method gets triggered
  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  onChangeInput(event) {
    this.handleChange.emit(event);
  }

  onClearSelected(event:any) {
    this.handleClear.emit(event);
  }
}
